<template>
    <div>
        {{ $t('notification.driveFolderDeleted', { 
            actor: $_.get(activity, 'actorUser.name'), 
            folderName: $_.get(activity, 'payload.folderName')
        }) }}
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "DriveFolderDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

